<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    :aria-label="'Icon' + iconName"
    role="presentation"
    class="inline-block"
    :class="iconType== 'loader' ? 'animate-spin': ''"
  >
    <g :fill="iconColor">
      <component :is="iconComponent" />
    </g>
  </svg>
</template>

<script setup>
import * as icons from './icons/index';

const props = defineProps({
  iconName: {
    type: String,
    default: 'box'
  },
  iconType: {
    type: String,
    default: ""
  },
  width: {
    type: [Number, String],
    default: 24
  },
  height: {
    type: [Number, String],
    default: 24
  },
  iconColor: {
    type: String,
    default: 'currentColor'
  }
});

const iconComponent = icons[props.iconType || props.iconName]
</script>
